import getEdsGif from '@mos/eds-gif/dist';

const SERVICES = body => ({
  Services: {
    'gia-appeal': body
  }
});

export const CLICK_APPLY_BUTTON = () =>
  SERVICES({ Главная: { 'Кнопка Подать апелляцию': { null: 'click' } } });
export const STEP_COMPLETE = stepName =>
  SERVICES({ Форма: { [stepName]: { null: 'next_step' } } });
export const CLICK_BUTTON_SUBMIT_APPEAL = () =>
  SERVICES({ Форма: { 'Отправка формы на последнем шаге': { null: 'send' } } });
export const TRACK_REQUEST_APPEAL_SUCCESS = () =>
  SERVICES({
    'Апелляция отправлена': { 'Успешная отправка формы': { null: 'accept' } }
  });
export const CLICK_NOT_CORRECT_EXAM = () =>
  SERVICES({
    'Попап Несоответствие бланков ответов вашей работе': {
      'Кнопка Отправить': { null: 'click' }
    }
  });
export const CLICK_CANCEL_APPEAL = () =>
  SERVICES({
    cancel: 'Нажал на кнопку Отозвать апелляцию'
  });
export const APPEAL_CANCEL_SUCCESS_STAT = () =>
  SERVICES({
    cancel: 'Апелляция отозвана успешно'
  });
export const APPEAL_CANCEL_ERROR_STAT = () =>
  SERVICES({
    cancel: 'Апелляция не отозвана (Доступ закрыт)'
  });

export const sendStats = eventObject => {
  const data = {
    eventType: 'services_mos',
    eventSrc:
      'https://www.mos.ru/services/podat-apellyatsiyu-na-rezultaty-gia/',
    eventDst: 'stats',
    eventObject
  };

  getEdsGif(data);

  if (window.yaCounter32628510) {
    window.yaCounter32628510.params(eventObject);
  }
};

export const sendFeedback = (ratingOrTextPlain, title) => {
  // https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
  const encodeUnicodeToBase64 = str =>
    btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
        String.fromCharCode(`0x${p1}`)
      )
    );

  const counter = window.yaCounter32628510;
  const feedbackType = typeof ratingOrTextPlain === 'number' ? 'Rate' : 'Text';
  const ratingOrText =
    feedbackType === 'Rate'
      ? ratingOrTextPlain
      : encodeUnicodeToBase64(ratingOrTextPlain);

  const feedbackData = [
    counter ? counter.getClientID() : '',
    document.cookie.includes('mos_id')
      ? document.cookie.replace(
          /(?:(?:^|.*;\s*)mos_id\s*=\s*([^;]*).*$)|^.*$/,
          '$1'
        )
      : null,
    window.location.href,
    'Услуги',
    'Обратная связь',
    feedbackType,
    title,
    null,
    null,
    ratingOrText
  ];

  fetch('/stproxy/services/', {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    credentials: 'include',
    method: 'POST',
    body: feedbackData.reduce((acc, item) => `${acc}\t"${item}"`, '')
  }).then(() => {
    // TODO: сделать нормальную обработку успеха и ошибок
    // console.log(resp);
  });

  return true;
};
